import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { noop } from 'app/shared';
import { UserService, User, ROLE } from './user';

@Component({
  template: ''
})
export class AppRedirectComponent implements OnInit {

  constructor(
    private router: Router,
    private userService: UserService
  ) { }

  ngOnInit() {
    this.userService.getUser()
    .then(
      (user: User) => {
        if (user === null) {
          this.navigateTo('login');

          return;
        }

        if (user.hasRole(ROLE.ADMIN) || user.hasRole(ROLE.SUPER_ADMIN)) {
          this.navigateTo('admin/dashboard');

          return;
        }

        if (user.hasRole(ROLE.COACH)) {
          this.navigateTo('coach/dashboard');

          return;
        }

        if (user.hasRole(ROLE.PARTICIPANT)) {
          this.navigateTo('participant/dashboard');

          return;
        }
      },
      noop
    );
  }

  private navigateTo(path: string) {
    this.router.navigate([path], { replaceUrl: true });
  }

}



// WEBPACK FOOTER //
// /dist/src/app/app-redirect.component.ts